import axios from "axios";

const base = process.env.REACT_APP_API_BASE_URL || "";
console.log("Axios Base URL:", base);

const axiosClient = axios.create({
  baseURL: base, 
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: false, // set to true if using cookies
});

export default axiosClient;